import React, { useState, useEffect, useRef } from "react";
import { api } from "common";
import { useTranslation } from "react-i18next";
import langlocales from "../lists/langlocales";
import datelocales from "../lists/datelocales";
import MaterialTable from "material-table";
import { useSelector, useDispatch } from "react-redux";
import BookIcon from "@mui/icons-material/Book";
import { Typography, Modal, Button, Grid, MenuItem } from "@mui/material";
import CircularLoading from "components/CircularLoading";
import { makeStyles } from "@mui/styles";
import TextField from "@mui/material/TextField";
import { colors } from "../components/Theme/WebTheme";
import { downloadCsv } from "../common/sharedFunctions";
import * as yup from "yup";
import "../styles/style.css";
const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    padding: theme.spacing(1),
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    width: 850,
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    overflow: "initial",
  },
  paper2: {
    width: 250,
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    overflow: "initial",
  },
}));

export default function LanguageSetting(props) {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir();
  const { editLanguage } = api;
  const rootRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [rowIndex, setRowIndex] = useState();
  const classes = useStyles();
  const [data, setData] = useState();
  const languagedata = useSelector((state) => state.languagedata);
  const dispatch = useDispatch();
  const settings = useSelector((state) => state.settingsdata.settings);
  const [keyValuePair, setKeyValuePair] = useState();
  const [completed, setCompleted] = useState(0);
  const [enSet, setEnSet] = useState();
  const [openLoader, setOpenLoader] = useState(false);
  const [addRowModalOpen, setAddRowModalOpen] = useState(false);
  const [newRowData, setNewRowData] = useState({});
  const [editing, setediting] = useState(false);
  const [oldData, setOlddata] = useState("");
  const handleAddrow = (newData) => {
    settings.AllowCriticalEditsAdmin
      ? new Promise((resolve) => {
          setTimeout(async () => {
            let kvSet = {};
            for (const value of Object.values(data)) {
              if (value.default) {
                kvSet = value.keyValuePairs;
              }
            }
            newData["createdAt"] = new Date().getTime();
            newData["default"] = false;
            setEnSet(kvSet);
            setOpenLoader(true);
            const keys = Object.keys(kvSet);
            let obj = {};
            for (let i = 0; i < keys.length; i++) {
              try {
                const response = await fetch(
                  `https://us-central1-exicube-test-delivery.cloudfunctions.net/gettranslation?str=${
                    kvSet[keys[i]]
                  }&from=en&to=${newData.langLocale}`,
                  {
                    method: "GET",
                    headers: {
                      "Content-Type": "application/json",
                    },
                  }
                );
                const json = await response.json();
                obj[keys[i]] = json.text;
              } catch (err) {
                obj[keys[i]] = kvSet[keys[i]];
              }
              setCompleted(parseInt(((i + 1) / keys.length) * 100));
            }
            newData["keyValuePairs"] = obj;
            dispatch(editLanguage(newData, "Add"));
            resolve();
            setOpenLoader(false);
            setCompleted(0);
          }, 600);
        })
      : new Promise((resolve) => {
          setTimeout(() => {
            resolve();
            alert(t("demo_mode"));
          }, 600);
        });
  };
  const handleUpdateRow = (newData, oldData) => {
    newData.id = oldData.id;
    settings.AllowCriticalEditsAdmin
      ? new Promise((resolve) => {
          setTimeout(() => {
            resolve();
            if (newData !== oldData) {
              delete newData.tableData;
              dispatch(editLanguage(newData, "Update"));
            }
          }, 600);
        })
      : new Promise((resolve) => {
          setTimeout(() => {
            resolve();
            alert(t("demo_mode"));
          }, 600);
        });
  };
  const handleOpenAddRowModal = (data) => {
    setAddRowModalOpen(true);
  };
  const handleCloseModal = () => {
    setAddRowModalOpen(false);
    setNewRowData({});
  };
  const columns = [
    {
      title: t("langName"),
      field: "langName",
      cellStyle: isRTL === "rtl" ? { paddingRight: 220 } : { paddingLeft: 220 },
      headerStyle:
        isRTL === "rtl" ? { paddingRight: 220 } : { paddingLeft: 220 },
    },
    {
      title: t("langLocale"),
      field: "langLocale",
      lookup: langlocales,
      cellStyle: { textAlign: isRTL === "rtl" ? "right" : "left" },
    },
    {
      title: t("dateLocale"),
      field: "dateLocale",
      lookup: datelocales,
      cellStyle: { textAlign: isRTL === "rtl" ? "right" : "left" },
    },
  ];

  useEffect(() => {
    if (languagedata.langlist) {
      setData(languagedata.langlist);
    } else {
      setData([]);
    }
  }, [languagedata.langlist, enSet]);

  const handleClose = () => {
    setKeyValuePair(null);
    setRowIndex(-1);
    setOpen(false);
  };

  const handleLoaderClose = () => {
    setCompleted(0);
    setOpenLoader(false);
  };

  const saveJson = () => {
    let newData = data[rowIndex];
    try {
      if (settings.AllowCriticalEditsAdmin) {
        let obj = {};
        for (let i = 0; i < keyValuePair.length; i++) {
          obj[keyValuePair[i][0]] = keyValuePair[i][1];
        }
        newData["keyValuePairs"] = obj;
        dispatch(editLanguage(newData, "Update"));
        handleClose();
      } else {
        alert(t("demo_mode"));
      }
    } catch (error) {
      alert("JSON Error");
    }
  };

  useEffect(() => {
    if (keyValuePair && keyValuePair.length > 0) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [keyValuePair]);

  const [selectedRow, setSelectedRow] = useState(null);

  return languagedata.loading ? (
    <CircularLoading />
  ) : (
    <div>
      <MaterialTable
        // title={t('language')}
        title={<span className="tableTitleStyle">{t("language")}</span>}
        columns={columns}
        style={{
          direction: isRTL === "rtl" ? "rtl" : "ltr",
          borderRadius: "16px",
          // marginTop: 30,
          boxShadow: "rgba(0, 0, 0, 0.1) 0px -0.4rem 3rem",
        }}
        data={data}
        onRowClick={(evt, selectedRow) =>
          setSelectedRow(selectedRow.tableData.id)
        }
        options={{
          exportCsv: (columns, data) => {
            let hArray = [];
            const headerRow = columns.map((col) => {
              if (typeof col.title === "object") {
                return col.title.props.text;
              }
              hArray.push(col.field);
              return col.title;
            });
            const dataRows = data.map(({ tableData, ...row }) => {
              row.createdAt =
                new Date(row.createdAt).toLocaleDateString() +
                " " +
                new Date(row.createdAt).toLocaleTimeString();
              let dArr = [];
              for (let i = 0; i < hArray.length; i++) {
                dArr.push(row[hArray[i]]);
              }
              return Object.values(dArr);
            });
            const { exportDelimiter } = ",";
            const delimiter = exportDelimiter ? exportDelimiter : ",";
            const csvContent = [headerRow, ...dataRows]
              .map((e) => e.join(delimiter))
              .join("\n");
            const csvFileName = "download.csv";
            downloadCsv(csvContent, csvFileName);
          },
          exportButton: {
            csv: settings.AllowCriticalEditsAdmin,
            pdf: false,
          },
          maxColumnSort: "all_columns",
          rowStyle: (rowData) => ({
            fontSize: "12px",
            // backgroundColor:
            //   selectedRow === rowData.tableData.id ? "#EEE" : "#FFF",
          }),
          editable: {
            // backgroundColor: colors.Header_Text,
            // fontSize: "0.8em",
            // fontWeight: "bold ",
            // fontFamily: 'Lucida Console", "Courier New", monospace',
            fontSize: "12px",
          },
          headerStyle: {
            position: "sticky",
            top: "0px",
            color: "#000",
            fontSize: "12px",
            fontWeight: "bold ",
            backgroundColor: "#e1e7f0",
            // backgroundColor: colors.Header_Text_back,
            // color: "#fff",
            // fontSize: "0.8em",
            // fontWeight: "bold ",
            // fontFamily: 'Lucida Console", "Courier New", monospace',
          },
        }}
        // actions={[
        //   (rowData) => ({
        //     icon: () => (
        //       <div
        //         style={{
        //           display: "flex",
        //           alignItems: "center",
        //           flexWrap: "wrap",
        //         }}
        //       >
        //         <BookIcon />
        //         <Typography variant="subtitle2">{t("make_default")}</Typography>
        //       </div>
        //     ),
        //     disabled: rowData.default || (completed > 0 && completed < 100),
        //     onClick: (event, rowData) => {
        //       if (settings.AllowCriticalEditsAdmin) {
        //         let curVal = rowData["default"];
        //         for (const value of Object.values(data)) {
        //           if (rowData.id === value.id) {
        //             value["default"] = !curVal;
        //           } else {
        //             value["default"] = curVal;
        //           }
        //           dispatch(editLanguage(value, "Update"));
        //         }
        //       } else {
        //         alert(t("demo_mode"));
        //       }
        //     },
        //   }),
        //   (rowData) => ({
        //     icon: () => (
        //       <div
        //         style={{
        //           display: "flex",
        //           alignItems: "center",
        //           flexWrap: "wrap",
        //         }}
        //       >
        //         <BookIcon />
        //         <Typography variant="subtitle2">{t("edit_json")}</Typography>
        //       </div>
        //     ),
        //     disabled: completed > 0 && completed < 100,
        //     onClick: (event, rowData) => {
        //       setRowIndex(rowData.tableData.id);
        //       setKeyValuePair(
        //         Object.entries(data[rowData.tableData.id].keyValuePairs)
        //       );
        //     },
        //   }),
        // ]}
        actions={[
          {
            icon: "edit",
            onClick: (event, rowData) => {
              // Do save operation
              setediting(true);
              setOlddata(rowData);
              handleOpenAddRowModal();
            },
          },
          {
            icon: "add",
            tooltip: "Add Row",
            isFreeAction: true,
            onClick: handleOpenAddRowModal,
          },
        ]}
        editable={{
          // onRowAdd: (newData) =>
          //   settings.AllowCriticalEditsAdmin
          //     ? new Promise((resolve) => {
          //         console.log(newData, "newData");
          //         setTimeout(async () => {
          //           let kvSet = {};
          //           for (const value of Object.values(data)) {
          //             if (value.default) {
          //               kvSet = value.keyValuePairs;
          //             }
          //           }
          //           newData["createdAt"] = new Date().getTime();
          //           newData["default"] = false;
          //           setEnSet(kvSet);
          //           setOpenLoader(true);
          //           const keys = Object.keys(kvSet);
          //           let obj = {};
          //           for (let i = 0; i < keys.length; i++) {
          //             try {
          //               const response = await fetch(
          //                 `https://us-central1-exicube-test-delivery.cloudfunctions.net/gettranslation?str=${
          //                   kvSet[keys[i]]
          //                 }&from=en&to=${newData.langLocale}`,
          //                 {
          //                   method: "GET",
          //                   headers: {
          //                     "Content-Type": "application/json",
          //                   },
          //                 }
          //               );
          //               const json = await response.json();
          //               obj[keys[i]] = json.text;
          //             } catch (err) {
          //               obj[keys[i]] = kvSet[keys[i]];
          //             }
          //             setCompleted(parseInt(((i + 1) / keys.length) * 100));
          //           }
          //           newData["keyValuePairs"] = obj;
          //           dispatch(editLanguage(newData, "Add"));
          //           resolve();
          //           setOpenLoader(false);
          //           setCompleted(0);
          //         }, 600);
          //       })
          //     : new Promise((resolve) => {
          //         setTimeout(() => {
          //           resolve();
          //           alert(t("demo_mode"));
          //         }, 600);
          //       }),
          // onRowUpdate: (newData, oldData) =>
          //   settings.AllowCriticalEditsAdmin
          //     ? new Promise((resolve) => {
          //         setTimeout(() => {
          //           resolve();
          //           if (newData !== oldData) {
          //             delete newData.tableData;
          //             dispatch(editLanguage(newData, "Update"));
          //           }
          //         }, 600);
          //       })
          //     : new Promise((resolve) => {
          //         setTimeout(() => {
          //           resolve();
          //           alert(t("demo_mode"));
          //         }, 600);
          //       }),
          onRowDelete: (oldData) =>
            settings.AllowCriticalEditsAdmin
              ? oldData.default
                ? new Promise((resolve) => {
                    setTimeout(() => {
                      resolve();
                      alert("Cannot delete default language");
                    }, 600);
                  })
                : new Promise((resolve) => {
                    setTimeout(() => {
                      resolve();
                      dispatch(editLanguage(oldData, "Delete"));
                    }, 600);
                  })
              : new Promise((resolve) => {
                  setTimeout(() => {
                    resolve();
                    alert(t("demo_mode"));
                  }, 600);
                }),
        }}
      />
      {rowIndex >= 0 ? (
        <Modal
          disablePortal
          disableEnforceFocus
          disableAutoFocus
          onClose={handleClose}
          open={open}
          className={classes.modal}
          container={() => rootRef.current}
        >
          <div className={classes.paper}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography
                  component="h1"
                  variant="h5"
                  className={classes.title}
                  style={{ textAlign: isRTL === "rtl" ? "right" : "left" }}
                >
                  {t("add_language")}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <div style={{ height: 400, overflowY: "auto" }}>
                  {keyValuePair.map((item, index) => (
                    <div key={"key" + item[0]}>
                      <TextField
                        margin="dense"
                        id="name"
                        label={item[0]}
                        type="numeric"
                        fullWidth
                        variant="standard"
                        onChange={(e) => {
                          let arr = [...keyValuePair];
                          arr[index][1] = e.target.value;
                          setKeyValuePair(arr);
                        }}
                        value={item[1]}
                      />
                    </div>
                  ))}
                </div>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                style={{
                  direction: isRTL === "rtl" ? "rtl" : "ltr",
                  marginLeft: isRTL === "rtl" ? "65%" : 0,
                  overflow: "initial",
                }}
              >
                <Button
                  onClick={handleClose}
                  variant="contained"
                  color="primary"
                >
                  {t("cancel")}
                </Button>
                <Button
                  onClick={saveJson}
                  variant="contained"
                  color="primary"
                  style={
                    isRTL === "rtl" ? { marginRight: 10 } : { marginLeft: 10 }
                  }
                >
                  {t("submit")}
                </Button>
              </Grid>
            </Grid>
          </div>
        </Modal>
      ) : null}
      {completed > 0 && completed < 100 ? (
        <Modal
          disablePortal
          disableEnforceFocus
          disableAutoFocus
          onClose={handleLoaderClose}
          open={openLoader}
          className={classes.modal}
          container={() => rootRef.current}
        >
          <div className={classes.paper2}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography
                  component="h1"
                  variant="h5"
                  className={classes.title}
                  style={{ textAlign: isRTL === "rtl" ? "right" : "left" }}
                >
                  {completed + " % COMPLETE"}
                </Typography>
              </Grid>
            </Grid>
          </div>
        </Modal>
      ) : null}

      <AddCARModel
        open={addRowModalOpen}
        onClose={handleCloseModal}
        handleAddRow={handleAddrow}
        oldData={oldData}
        langlocales={langlocales}
        datelocales={datelocales}
        editing={editing}
        setediting={setediting}
        handleUpdateRow={handleUpdateRow}
        setOlddata={setOlddata}
      />
    </div>
  );
}

const AddCARModel = ({
  open,
  onClose,
  handleAddRow,
  editing,
  langlocales,
  datelocales,
  oldData,
  carz,
  setediting,
  handleUpdateRow,
  drivers,
  setOlddata,
}) => {
  const [languageName, setLanguageName] = useState("");
  const [languageLocal, setLanguageLocal] = useState("");
  const [dateLocal, setDateLocal] = useState("");
  const [errors, setErrors] = useState({});

  const schema = yup.object().shape({
    languageName: yup.string().required("Language Name is required"),
    languageLocal: yup.string().required("Language Local is required"),
    dateLocal: yup.string().required("Date Local is required"),
  });

  const validateForm = async () => {
    try {
      await schema.validate(
        {
          languageName,
          languageLocal,
          dateLocal,
        },
        { abortEarly: false }
      );
      setErrors({});
      return true;
    } catch (validationErrors) {
      const errorsMap = {};
      validationErrors.inner.forEach((error) => {
        errorsMap[error.path] = error.message;
      });
      setErrors(errorsMap);
      return false;
    }
  };

  useEffect(() => {
    if (oldData) {
      setLanguageName(oldData.langName || "");
      setLanguageLocal(oldData.langLocale || "");
      setDateLocal(oldData.dateLocale || "");
    }
  }, [oldData]);

  const handleAddCar = async () => {
    const isValid = await validateForm();
    if (!isValid) return;

    // Perform your logic to add/update the car here
    const carData = {
      langName: languageName,
      langLocale: languageLocal,
      dateLocale: dateLocal,
      createdAt: new Date().toISOString(),
      default: true,
    };
    if (editing) {
      handleUpdateRow(carData, oldData);
    } else {
      handleAddRow(carData);
    }

    setediting(false);

    // Reset the form
    setLanguageName("");
    setLanguageLocal("");
    setDateLocal("");
    setErrors("");
    setOlddata("");
    // Close the modal
    onClose();
  };

  const handleClose = () => {
    // Reset the form
    setLanguageName("");
    setLanguageLocal("");
    setDateLocal("");
    setediting(false);
    setErrors("");
    setOlddata("");

    // Close the modal
    onClose();
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <div
        className="modal-container"
        style={{
          backgroundColor: "white",
          width: "80%",
          margin: "auto",
          marginTop: "3vh",
          padding: "20px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          overflow: "scroll",
          maxHeight: "90vh", // Add max height for scrolling
          scrollbarWidth: "thin", // Width of the scrollbar
          scrollbarColor: "#888 #f1f1f1", // Color of the scrollbar thumb and track
        }}
      >
        <h2>{editing ? "Edit" : "Add"} Language</h2>
        <TextField
          label="Language Name"
          value={languageName}
          onChange={(e) => setLanguageName(e.target.value)}
          error={errors.languageName !== undefined}
          helperText={errors.languageName}
          required
          style={{ width: "100%", marginBottom: "10px" }}
        />

        <TextField
          select
          label="Language Local"
          value={languageLocal}
          onChange={(e) => setLanguageLocal(e.target.value)}
          error={errors.languageLocal !== undefined}
          helperText={errors.languageLocal}
          required
          style={{ width: "100%", marginBottom: "10px" }}
        >
          <MenuItem value="">Select Language Local</MenuItem>
          {Object.keys(langlocales)?.map((itm, i) => {
            return (
              <MenuItem key={i} value={itm}>
                {itm}
              </MenuItem>
            );
          })}
        </TextField>

        <TextField
          select
          label="Date Local"
          value={dateLocal}
          onChange={(e) => setDateLocal(e.target.value)}
          error={errors.dateLocal !== undefined}
          helperText={errors.dateLocal}
          required
          style={{ width: "100%", marginBottom: "10px" }}
        >
          <MenuItem value="">Select Date Local</MenuItem>
          {Object.keys(datelocales)?.map((itm, i) => {
            return (
              <MenuItem key={i} value={itm}>
                {itm}
              </MenuItem>
            );
          })}
        </TextField>

        <div className="button-container" style={{ marginTop: "20px" }}>
          <Button
            variant="contained"
            onClick={handleAddCar}
            style={{ backgroundColor: "darkblue", color: "white" }}
          >
            {editing ? "Update" : "Add"}
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={handleClose}
            style={{
              backgroundColor: "darkblue",
              color: "white",
              marginLeft: "10px",
            }}
          >
            Cancel
          </Button>
        </div>
      </div>
    </Modal>
  );
};
